// extracted by css-extract-rspack-plugin
export default {"root":"Q_C1K","button":"vfgco"};